import React, { useEffect, useRef } from 'react';
import ThinxLogo from '../header/thinx-logo';
import CloseIcon from '../utils/icon/icon-close.svg';

const Modal = ({ children, closeModal, classNames }) => {
  const modalRef = useRef(null);
  useEffect(() => {
    const focusableElements = modalRef.current.querySelectorAll('a, button, input');
    focusableElements.forEach((el) => el.setAttribute('tabindex', '-1'));
    const handleFirstTab = (e) => {
      if (e.key === 'Tab') {
        focusableElements.forEach((el) => el.removeAttribute('tabindex'));
        window.removeEventListener('keydown', handleFirstTab);
      }
    };
    window.addEventListener('keydown', handleFirstTab);
    return () => {
      window.removeEventListener('keydown', handleFirstTab);
    };
  }, []);

  return (
    <div
      ref={modalRef}
      className={`modal rounded-5 ${classNames} relative`}
      onClick={(e) => e.stopPropagation()}
    >
      <span tabIndex={-1}>
        <button
          type="button"
          onClick={closeModal}
          aria-label={window.TMW.Strings.cart.close}
          className="absolute right-3 top-3 [&>svg]:size-6"
        >
          <CloseIcon />
        </button>
      </span>
      <div className="flex h-full flex-col">
        <div className="mt-8 flex justify-center">
          <ThinxLogo />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
